import './Loading.css';

export const Loading= ()=>{

    const w = 40;

    return (
        <div className="loading-spinner-container">
        <div className="loadingio-spinner-blocks-v3nyk9acybi">
            <div className="ldio-diyuauke7pb" style={{width:`${w*3}px`, height:`${w*3}px`}}>
                
                <div style={{left:`${0 * w}px`,top:`${0 * w}px`,animationDelay:'0s'}}></div>
                <div style={{left:`${1 * w}px`,top:`${0 * w}px`,animationDelay:'0.125s'}}></div>
                <div style={{left:`${2 * w}px`,top:`${0 * w}px`,animationDelay:'0.25s'}}></div>
                <div style={{left:`${0 * w}px`,top:`${1 * w}px`,animationDelay:'0.875s'}}></div>                
                <div style={{left:`${2 * w}px`,top:`${1 * w}px`,animationDelay:'0.375s'}}></div>
                <div style={{left:`${0 * w}px`,top:`${2 * w}px`,animationDelay:'0.75s'}}></div>
                <div style={{left:`${1 * w}px`,top:`${2 * w}px`,animationDelay:'0.625s'}}></div>
                <div style={{left:`${2 * w}px`,top:`${2 * w}px`,animationDelay:'0.5s'}}></div>
                

                {/* <div style='left:320px;top:152px;animation-delay:0.125s'></div>
                <div style='left:488px;top:152px;animation-delay:0.25s'></div>                
                <div style='left:152px;top:320px;animation-delay:0.875s'></div>
                <div style='left:488px;top:320px;animation-delay:0.375s'></div>
                <div style='left:152px;top:488px;animation-delay:0.75s'></div>
                <div style='left:320px;top:488px;animation-delay:0.625s'></div>
                <div style='left:488px;top:488px;animation-delay:0.5s'></div> */}
            </div>
        </div>
        </div>
        
    );
};